import { render, staticRenderFns } from "./ResourceEventList.vue?vue&type=template&id=6fc5c89f"
import script from "./ResourceEventList.ts?vue&type=script&lang=ts&external"
export * from "./ResourceEventList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports